<template>
  <v-sheet class="text-start">
    <page-head title="Report" :breadcrumb="['Facility', 'Report']">
      <template v-slot>
        <v-btn
          variant="outlined"
          color="primary"
          :to="{ name: 'facilityIssueReport' }"
          ><v-icon>mdi-file-document-outline</v-icon>Issue Report</v-btn
        >
      </template>
    </page-head>
    <v-data-table-server
      :items="dataTable.items"
      :items-per-page="dataTable.itemsPerPage"
      :items-length="dataTable.totalItems"
      :headers="dataTable.headers"
      :loading="dataTable.isLoading"
      :items-per-page-options="dataTable.itemsPerPageOptions"
      @update:options="updateReport"
    >
    </v-data-table-server>
  </v-sheet>
</template>

<script setup>
import moment from "moment";
import PageHead from "@/components/admin_theme/PageHead.vue";
import { reactive } from "vue";
import { authAxios } from "@/util/Axios";
import { DEFAULT_DATATABLE } from "@/util/List";

const axios = authAxios();
const dataTable = reactive({
  headers: [
    { title: "Attendee", key: "attendee", align: "start", sortable: false },
    { title: "Create DT", key: "create_dt", align: "start", sortable: false },
    { title: "Branch", key: "branch", align: "start", sortable: false },
    { title: "Resource", key: "resource", align: "start", sortable: false },
    { title: "Date", key: "display_date", align: "start", sortable: false },
    { title: "Time", key: "display_time", align: "start", sortable: false },
    { title: "Amount", key: "amount", align: "start", seortable: false },
    { title: "Price", key: "net_price", align: "start", sortable: false },
    { title: "Status", key: "status", align: "start", sortable: false },
  ],
  ...DEFAULT_DATATABLE,
});

function updateReport({ page, itemsPerPage }) {
  dataTable.isLoading = true;
  loadReport(page, itemsPerPage).then((response) => {
    var result = [];
    dataTable.isLoading = false;
    response.data.data.forEach((item) => {
      result.push({
        ...item,
        create_dt: moment(item.transaction_start_local_dt).format(
          "MMM DD, YYYY HH:mm"
        ),
        display_date: moment(item.date).format("MMM DD, YYYY"),
        display_time: displayTime(item.start_time),
      });
    });
    dataTable.items = [...result];
    dataTable.totalItems = response.data.total_items;
  });
}

function displayTime(times) {
  let result = [];
  times.forEach((t) => {
    result.push(moment(t, "HH:mm:ss").format("HH:mm"));
  });
  return result.join(", ");
}

function loadReport(page, length) {
  return axios({
    method: "GET",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/facility_booking/vuetify`,
    params: { page: page, length: length, search: "" },
  });
}
</script>
